<div style="display: contents">
  <div class="img-container" [ngClass]="mode === 'learning' ? '-learning' : ''">
    <img [src]="img" />
  </div>
  <div class="text-container" [ngClass]="mode === 'learning' ? '-learning' : ''">
    <ng-content></ng-content>
  </div>
  @if (mode=='gradient') {
  <div class="masthead-gradient-background"></div>
  }
</div>
